"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.dynamicListings.name': '动态列表',
    'tools.dynamicListings.description': '当满足特定对话条件时，显示与上下文相关的列表面板',
};
